<script setup>
import IconBase from '@/components/icon/IconBase.vue';
import IconStarRounded from '@/components/icon/IconStarRounded.vue';
import IconStarRoundedOutline from '@/components/icon/IconStarRoundedOutline.vue';

defineProps({
	starred: { type: Boolean, default: false },
	size: { type: [Number, String], default: 20 },
});
</script>

<template>
	<icon-base v-if="starred" :width="size" :height="size" width-view-box="20" height-view-box="20" fill="none"
		class="text-yellow">
		<icon-star-rounded />
	</icon-base>
	<icon-base v-else :width="size" :height="size" width-view-box="20" height-view-box="20" fill="none" class="text-white">
		<icon-star-rounded-outline />
	</icon-base>
</template>
